<template>
  <div data-context-menu class="absolute overflow-hidden rounded bg-white z-30 shadow">
    <div @click="deleteTime" class="flex items-center p-2 text-red hover:bg-red-lightest cursor-pointer">
      <icon class="w-6 h-6 mr-1" name="bin" :center="false" /> Delete
    </div>
    <div @click="repeatToggle" class="flex items-center p-2 hover:bg-grey-lightest cursor-pointer">
      <icon class="w-6 h-6 mr-1" name="calendar" :center="false" />
      {{ time.type === types.TIME_TYPE_REPEATED ? 'Stop Repeating' : 'Start Repeating' }}
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AvailablityContextMenu',

  props: ['event', 'time', 'weekOffset'],

  data () {
    return {
      types: {
        TIME_TYPE_UNSET: 0,
        TIME_TYPE_SINGLE: 1,
        TIME_TYPE_REPEATED: 2
      }
    }
  },

  mounted () {
    this.positionMenu()
  },

  methods: {
    ...mapActions([
      'deleteAvailabilityTime',
      'toggleRepeatingAvailabilityTime'
    ]),

    deleteTime () {
      this.deleteAvailabilityTime({
        offset: this.weekOffset,
        time: this.time
      })
    },

    repeatToggle () {
      let newType = this.time.type === this.types.TIME_TYPE_REPEATED
        ? this.types.TIME_TYPE_SINGLE
        : this.types.TIME_TYPE_REPEATED

      this.toggleRepeatingAvailabilityTime({
        oldType: this.time.type,
        time: {
          ...this.time,
          type: newType
        }
      })
    },

    positionMenu () {
      let contextmenu = this.$el

      let top = 0
      let left = 0

      // Make sure we are not going to touch the edges of the page.
      if ((this.event.pageX + contextmenu.clientWidth) > window.innerWidth) {
        left += contextmenu.clientWidth
      }

      if ((this.event.pageY + contextmenu.clientHeight) > window.innerHeight) {
        top += contextmenu.clientHeight
      }

      contextmenu.style.top = (this.event.pageY - top) + 'px'
      contextmenu.style.left = (this.event.pageX - left) + 'px'
    }
  },

  watch: {
    event () {
      this.positionMenu()
    }
  }
}
</script>
